/* MT/26 — one deferred script for all mt-* sections.
   Vanilla, no deps. Safe re-init on shopify:section:load (theme editor). */
(function () {
  'use strict';

  /* ---------- reveal on scroll (IntersectionObserver, content visible without JS) ---------- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.mt-reveal:not(.mt-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- marquee: duplicate content so -50% loop is seamless ---------- */
  function initMarquee(scope) {
    (scope || document).querySelectorAll('.mt-marquee__track:not([data-mt-ready])').forEach(function (track) {
      track.dataset.mtReady = '1';
      var html = track.innerHTML;
      // ensure track is at least 2x viewport, then double for the loop
      while (track.scrollWidth < window.innerWidth * 1.2 && track.children.length < 40) track.innerHTML += html;
      track.innerHTML += track.innerHTML;
    });
  }

  /* ---------- hero slider ---------- */
  function initHero(scope) {
    (scope || document).querySelectorAll('.mt-hero:not([data-mt-ready])').forEach(function (hero) {
      hero.dataset.mtReady = '1';
      var slides = hero.querySelectorAll('.mt-hero__slide');
      if (slides.length < 2) return;
      var dots = hero.querySelectorAll('.mt-hero__dot');
      var count = hero.querySelector('.mt-hero__count');
      var i = 0, timer = null;
      var autoplay = parseInt(hero.dataset.autoplay || '0', 10);
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('mt-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('mt-active', k === i); });
        if (count) count.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      }
      function play() { if (autoplay > 0) { stop(); timer = setInterval(function () { show(i + 1); }, autoplay * 1000); } }
      function stop() { if (timer) clearInterval(timer); }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); play(); }); });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', play);
      show(0); play();
    });
  }

  /* ---------- best sellers tabs ---------- */
  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-mt-tabs]:not([data-mt-ready])').forEach(function (root) {
      root.dataset.mtReady = '1';
      var tabs = root.querySelectorAll('.mt-tab');
      var panels = root.querySelectorAll('.mt-tabpanel');
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x, j) { x.classList.toggle('mt-active', j === k); x.setAttribute('aria-selected', j === k); });
          panels.forEach(function (p, j) { p.hidden = j !== k; });
        });
      });
    });
  }

  /* ---------- quick view / quick add ---------- */
  var qv = null;
  function money(cents) {
    var fmt = (window.MT_MONEY_FORMAT || '${{amount}}');
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }
  function buildQv() {
    if (qv) return qv;
    qv = document.createElement('div');
    qv.className = 'mt-qv';
    qv.innerHTML =
      '<div class="mt-qv__backdrop" data-qv-close></div>' +
      '<div class="mt-qv__panel" role="dialog" aria-modal="true" aria-label="Quick buy">' +
        '<div class="mt-qv__img"><img alt="" loading="lazy"></div>' +
        '<div class="mt-qv__body">' +
          '<button class="mt-qv__close" data-qv-close aria-label="Close">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
          '<p class="mt-qv__eyebrow"></p>' +
          '<h3 class="mt-qv__title"></h3>' +
          '<div class="mt-qv__prices"><span class="mt-qv__price"></span><s class="mt-qv__compare"></s></div>' +
          '<div class="mt-qv__options"></div>' +
          '<p class="mt-qv__error"></p>' +
          '<div class="mt-qv__row">' +
            '<span class="mt-qv__qty"><button type="button" data-qv-minus aria-label="Decrease">−</button><input type="text" value="1" inputmode="numeric" aria-label="Quantity"><button type="button" data-qv-plus aria-label="Increase">+</button></span>' +
            '<button class="mt-btn mt-btn--ink mt-qv__atc" type="button"></button>' +
          '</div>' +
          '<div class="mt-qv__foot"><span class="mt-qv__trust">Free US shipping over $49.99 \u00b7 30-day returns</span><a class="mt-qv__link" href="#">View full details \u2192</a></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(qv);
    qv.addEventListener('click', function (e) { if (e.target.closest('[data-qv-close]')) closeQv(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQv(); });
    qv.querySelector('[data-qv-minus]').addEventListener('click', function () { var inp = qv.querySelector('.mt-qv__qty input'); inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) - 1); });
    qv.querySelector('[data-qv-plus]').addEventListener('click', function () { var inp = qv.querySelector('.mt-qv__qty input'); inp.value = (parseInt(inp.value, 10) || 1) + 1; });
    return qv;
  }
  function closeQv() { if (qv) { qv.classList.remove('mt-open'); document.body.style.overflow = ''; } }

  function openQv(handle) {
    buildQv();
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); })
      .then(function (p) {
        var state = { qty: 1, sel: {} };
        p.options.forEach(function (o) { state.sel[o.name] = o.values[0]; });
        qv.querySelector('.mt-qv__title').textContent = p.title;
        var gsmMatch = p.title.match(/\b([1-3][0-9]{2})\b/);
        qv.querySelector('.mt-qv__eyebrow').textContent = (p.type || 'Merino wool') + (gsmMatch ? ' \u00b7 ' + gsmMatch[1] + ' GSM' : '');
        qv.querySelector('.mt-qv__link').href = p.url;
        var img = qv.querySelector('.mt-qv__img img');
        if (p.featured_image) { img.src = p.featured_image; img.alt = p.title; }
        var optWrap = qv.querySelector('.mt-qv__options');
        optWrap.innerHTML = '';
        function currentVariant() {
          return p.variants.find(function (v) {
            return p.options.every(function (o, k) { return v.options[k] === state.sel[o.name]; });
          });
        }
        function render() {
          var v = currentVariant();
          var priceEl = qv.querySelector('.mt-qv__price');
          var cmpEl = qv.querySelector('.mt-qv__compare');
          var atc = qv.querySelector('.mt-qv__atc');
          if (v) {
            priceEl.textContent = money(v.price);
            if (v.compare_at_price && v.compare_at_price > v.price) { cmpEl.textContent = money(v.compare_at_price); cmpEl.style.display = ''; priceEl.style.color = 'var(--mt-accent)'; }
            else { cmpEl.style.display = 'none'; priceEl.style.color = ''; }
            atc.textContent = v.available ? ('Add to cart · ' + money(v.price)) : 'Sold out';
            atc.disabled = !v.available;
            atc.dataset.variantId = v.id;
          } else { atc.textContent = 'Unavailable'; atc.disabled = true; }
          optWrap.querySelectorAll('.mt-qv__opt').forEach(function (b) {
            b.classList.toggle('mt-active', state.sel[b.dataset.opt] === b.dataset.val);
          });
        }
        p.options.forEach(function (o) {
          if (o.values.length < 2 && o.name.toLowerCase() === 'title') return;
          var group = document.createElement('div');
          group.innerHTML = '<p class="mt-qv__label">' + o.name + '</p>';
          var row = document.createElement('div');
          row.className = 'mt-qv__opts';
          o.values.forEach(function (val) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'mt-qv__opt'; b.textContent = val;
            b.dataset.opt = o.name; b.dataset.val = val;
            b.addEventListener('click', function () { state.sel[o.name] = val; render(); });
            row.appendChild(b);
          });
          group.appendChild(row);
          optWrap.appendChild(group);
        });
        qv.querySelector('.mt-qv__atc').onclick = function () {
          var btn = this;
          var vid = btn.dataset.variantId;
          if (!vid) return;
          btn.disabled = true; btn.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: parseInt(vid, 10), quantity: parseInt(qv.querySelector('.mt-qv__qty input').value, 10) || 1 }),
          })
            .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
            .then(function () {
              closeQv();
              openThemeCartDrawer();
            })
            .catch(function () {
              var err = qv.querySelector('.mt-qv__error');
              err.textContent = 'Could not add to cart. Please try again.';
              err.style.display = 'block';
              btn.disabled = false; render();
            });
        };
        qv.querySelector('.mt-qv__error').style.display = 'none';
        qv.querySelector('.mt-qv__qty input').value = 1;
        render();
        qv.classList.add('mt-open');
        document.body.style.overflow = 'hidden';
      })
      .catch(function () { window.location.href = '/products/' + handle; });
  }

  /* Open the cart drawer after ajax add: MT drawer (mt-cart.js) if present, else Symmetry's; graceful fallbacks. */
  function openThemeCartDrawer(variantId) {
    if (document.querySelector('[data-mt-cart-drawer]') && window.MT && MT.openCart && MT.openCart !== openThemeCartDrawer) { MT.openCart(); return; }
    try {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        // Symmetry (Clean Canvas): refresh the drawer's cart-form from /cart, then open it
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { cartDrawerOpen: true, variantId: variantId || null } }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: null } }));
        // header count: re-render the header section and copy the count badge
        fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.mt-hdr__count, [data-mt-cart-count]').forEach(function (n) { n.textContent = cart.item_count; n.hidden = !cart.item_count; });
        }).catch(function () {});
        return;
      }
      window.location.href = '/cart';
    } catch (e) { window.location.href = '/cart'; }
  }

  function initQuickAdd(scope) {
    (scope || document).addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mt-quick-add]');
      if (!btn) return;
      e.preventDefault();
      openQv(btn.dataset.mtQuickAdd);
    });
  }

  /* ---------- boot ---------- */
  function initAll(scope) {
    initReveal(scope); initMarquee(scope); initHero(scope); initTabs(scope);
  }
  window.MT = window.MT || {};
  window.MT.openCart = window.MT.openCart || openThemeCartDrawer;
  window.MT.money = money;
  window.MT.init = function (scope) { initAll(scope); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); initQuickAdd(); });
  else { initAll(); initQuickAdd(); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
